export var GizaCamera;
(function (GizaCamera) {
    GizaCamera["MAIN"] = "camera_main";
    GizaCamera["MAIN_ZOOM"] = "camera_main_zoom";
    GizaCamera["SIDE_MAIN"] = "camera_side_main";
    GizaCamera["SIDE_ZOOM"] = "camera_side_zoom";
})(GizaCamera || (GizaCamera = {}));
